import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getSolution, getMaterialPrice, setQuotation
} from 'services/redux/sales/projectOnboarding/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import AddQuotation from './addQuotation';

const mapStateToProps = (state) => ({
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
  solution: state.projectOnboardingReducer.solution
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      documentUploadUrlPublic,
      getSolution,
      getMaterialPrice,
      setQuotation
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AddQuotation);
